import moment from "moment-timezone";
import _ from "lodash";
import { User } from "../store/store";
import { Apollo } from "@/decorators";
import { State2Way } from "@/decorators";

import { newCommonFormatCurrency } from "../../../backend/src/common/services/mathServices";
import { getUserDisplayName } from "../services/userServices";

import {
    socialAccountableAccounts,
    stateAccountableAccounts,
} from "../services/accountableAccountServices";
// reconciliation
import RECONCILIATION_QUERY from "../graphql/reconciliation/Reconciliation.gql";
import BANKTRANSACTION_QUERY from "../graphql/reconciliation/BankTransaction.gql";
import ACCOUNTING_LINES_QUERY from "../graphql/reconciliation/AccountingLineForReconciliation.gql";
// Chat
import UPDATE_BANKTRANSACTION_CHAT from "../graphql/UpdateBankTransactionChat.gql";
import BANKTRANSACTIONS_PREV_NEXT_QUERY from "../graphql/bankTransaction/PrevNextBankTransaction.gql";
import { computeNotJustifiedAmountSigned } from "../services/bankTransactionServices";
import { ComponentBase } from "./ComponentBase";
import { Component, Vue } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    emits: ["previous", "next"],
})
export class ReconciliationBase extends ComponentBase {
    @Prop({ default: false }) inbeddedMode: boolean;
    @Prop({ default: "Router" }) mode: string;

    @Prop({ default: "" }) companyId: string;
    @Prop({ default: "" }) bankTransactionId: string;
    @Prop({ default: "" }) documentId: string;
    @Prop({ default: "" }) reconciliationId: string;
    @Prop({ default: "" }) accountingLineId: string;

    @Prop({ default: false }) nextIdIsset: boolean;
    @Prop({ default: false }) previousIdIsset: boolean;

    @State2Way("updateToBeDoneStatus", "toBeDoneStatus")
    toBeDoneStatus!: boolean;

    @State2Way("updateBankTransactionPrevNext", "bankTransactionFilter.prevNext")
    prevNext!: any;

    get toBeDoneMode() {
        return this.mode === "ToBeDone";
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    back() {
        // debugger;
        if (this.toBeDoneStatus) {
            this.toBeDoneStatus = false;
            // this.$router.back();
            this.$router.go(-1);
        } else {
            this.$router.go(-1);
        }
    }

    itemReconciliations = {};

    reconciliation: any = {
        type: "DEFAULT",
        id: "",
        accountingLines: [],
        bankTransactions: [],
        status: "EDITION",
    };

    bankTransaction: any = {
        id: "",
        wordingOriginal: "",
        amount: 0.0,
        dateDebit: "",
        reconciliation: undefined,
    };

    document: any = {
        id: "",
        name: "",
        grossAmountSigned: 0.0,
        date: "",
        reconciliation: undefined,
    };

    accountingLine;

    reconciliationItems = [];

    groupedAccountingLines = [];

    waitingAA = { name: "471000", description: "Compte d'attente" };
    bankAA = { name: "512000", description: "Banque" };
    //
    // common refresh
    //
    loading = false;

    get selectedCompany() {
        // debugger;
        return this.$store.getters.getCompany(this.companyId);
        // return this.companyId;
    }

    get isIncomingOutgoingPayment() {
        if (
            this.selectedCompany.profile &&
            this.selectedCompany.profile.accountingType === "INCOMING_OUTGOING_PAYMENT"
        ) {
            return true;
        }
        return false;
    }

    initReconciliation() {
        const defaultReconciliation = {
            id: "",
            status: "EDITION",
            documents: [],
            bankTransactions: [],
        };
        return Object.assign({}, defaultReconciliation, {});
    }

    async commonReconciliationRefresh(reconciliationId) {
        const result = await this.$apollo.query({
            query: RECONCILIATION_QUERY,
            variables: {
                reconciliationId: reconciliationId,
            },
            fetchPolicy: "network-only",
        });
        const data = _.cloneDeep(result.data);

        if (data.reconciliation) {
            this.reconciliation = data.reconciliation;
            // this.loading = false;
            if (this.bankTransactionId) {
                for (let bti = 0; bti < this.reconciliation.bankTransactions.length; bti++) {
                    if (this.reconciliation.bankTransactions[bti].id === this.bankTransactionId) {
                        this.bankTransaction = this.reconciliation.bankTransactions[bti];
                        break;
                    }
                }
            }
            if (this.documentId) {
                for (const accountingLine of this.reconciliation.accountingLines) {
                    if (accountingLine.document && accountingLine.document.id === this.documentId) {
                        this.document = accountingLine.document;
                        break;
                    }
                }
            }
        }
    }

    async commonRefresh() {
        this.loading = true;
        if (this.reconciliationId) {
            await this.commonReconciliationRefresh(this.reconciliationId);
        } else {
            this.reconciliation = this.initReconciliation();
            if (this.bankTransactionId) {
                const result = await this.$apollo.query({
                    query: BANKTRANSACTION_QUERY,
                    variables: {
                        bankTransactionId: this.bankTransactionId,
                    },
                    fetchPolicy: "network-only",
                });
                const data = _.cloneDeep(result.data);
                if (data?.bankTransaction) {
                    if (data.bankTransaction.reconciliation) {
                        await this.commonReconciliationRefresh(
                            data.bankTransaction.reconciliation.id,
                        );
                    } else {
                        this.bankTransaction = data.bankTransaction;
                    }
                } else {
                    debugger;
                }
            } else if (this.documentId || this.accountingLineId) {
                const result = await this.$apollo.query({
                    query: ACCOUNTING_LINES_QUERY,
                    variables: {
                        documentId: this.documentId,
                        accountingLineId: this.accountingLineId,
                    },
                    fetchPolicy: "network-only",
                });
                const data = _.cloneDeep(result.data);
                if (data?.accountingLines?.length) {
                    for (const al of data.accountingLines) {
                        this.accountingLine = al;
                        this.document = al.document;
                        break;
                    }
                } else {
                    debugger;
                }
            } else {
                debugger;
            }
        }

        this.computeReconciliationItems();
        this.loading = false;
    }
    //
    // previous next
    //

    addPrevNextSmartQuery() {}

    @Apollo({
        query: BANKTRANSACTIONS_PREV_NEXT_QUERY,
        variables() {
            return this.getPrevNextVariables();
        },
        // deep: false,
        specificResult({ data, loading, networkStatus }) {
            // this.debug += 1;
            console.log(loading);
            if (!loading) {
                if (data) {
                    this.nextBankTransactionId =
                        data.nextBankTransactionId && data.nextBankTransactionId.length > 0
                            ? data.nextBankTransactionId[0].id
                            : "";

                    this.previousBankTransactionId =
                        data.previousBankTransactionId && data.previousBankTransactionId.length > 0
                            ? data.previousBankTransactionId[0].id
                            : "";
                } else {
                    this.previousBankTransactionId = "";
                    this.nextBankTransactionId = "";
                }
                this.prevNext = {
                    currentId: this.bankTransactionId,
                    prevId: this.previousBankTransactionId,
                    nextId: this.nextBankTransactionId,
                };
            }
        },
        skip() {
            return (
                this.toBeDoneStatus ||
                !this.bankTransactionId ||
                this.skipQuery ||
                !this.accountId ||
                (this.prevNext && this.prevNext.currentId === this.bankTransactionId)
            );
        },
    })
    previousBankTransactionId = "";

    nextBankTransactionId = "";

    nextDisabled() {
        if (this.toBeDoneMode) {
            // from tobedone
            return !this.previousIdIsset;
        }
        return this.nextBankTransactionId === "";
    }

    previousDisabled() {
        if (this.toBeDoneMode) {
            // from tobedone
            return !this.previousIdIsset;
        }
        return this.previousBankTransactionId === "";
    }

    previous() {
        if (this.toBeDoneMode) {
            this.$emit("previous");
        } else if (this.previousBankTransactionId) {
            const params: any = {
                companyId: this.companyId,
                bankTransactionId: this.previousBankTransactionId,
            };
            this.$router.replace({
                name: "reconciliation/bankTransaction",
                params: params,
            });
        }
    }

    next() {
        debugger;
        if (this.toBeDoneMode) {
            this.$emit("next");
        } else if (this.nextBankTransactionId) {
            const params: any = {
                companyId: this.companyId,
                bankTransactionId: this.nextBankTransactionId,
            };
            this.$router.replace({
                name: "reconciliation/bankTransaction",
                params: params,
            });
        }
    }

    //
    // status
    //

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    get isAccountingUser() {
        return this.currentUser.isAccountingUser;
    }

    getCashBoxWithBTReconciliation(group) {
        let bt;
        let cashBoxDoc;
        // let cashBoxBt
        const reconciliation = group.reconciliation;
        if (!reconciliation) {
            return undefined;
        }
        if (reconciliation.type !== "CASH_BOX") {
            return undefined;
        }
        for (const item of group.items) {
            if (item.doc) {
                if (item.doc.type === "MISCELLANEOUS_OPERATION") {
                    if (cashBoxDoc) {
                        return undefined;
                    }
                    cashBoxDoc = item.bt;
                }
            }
        }
        if (!cashBoxDoc) {
            return undefined;
        }
        for (const item of group.items) {
            if (item.bt) {
                if (!item.bt.account) {
                    return undefined;
                }
                if (item.bt.account && item.bt.account.type === "BANK") {
                    bt = item.bt;
                    break;
                }
            }
        }
        if (bt && cashBoxDoc) {
            return reconciliation;
        }
        return undefined;
    }

    getCashBoxWithDocumentReconciliation(group) {
        let accountingLine;
        let cashBoxDoc;
        const reconciliation = group.reconciliation;
        if (!reconciliation) {
            return undefined;
        }
        if (reconciliation.type !== "CASH_BOX") {
            return undefined;
        }

        for (const item of group.items) {
            if (item.accountingLine && item.doc) {
                if (item.doc.type === "MISCELLANEOUS_OPERATION") {
                    if (cashBoxDoc) {
                        return undefined;
                    }
                    cashBoxDoc = item.doc;
                } else if (!item.doc.zTillReceipt) {
                    accountingLine = item.accountingLine;
                } else {
                    return undefined;
                }
            }
        }
        if (accountingLine && cashBoxDoc) {
            return reconciliation;
        }
        return undefined;
    }

    getRemittanceWithDocumentReconciliation(group) {
        let waitingCashing;
        const reconciliation = group.reconciliation;
        if (!reconciliation) {
            return undefined;
        }
        for (const item of group.items) {
            if (item.bt) {
                return undefined;
            }
            if (item.doc && item.doc.type === "WAITING_CASHING") {
                if (waitingCashing) {
                    return undefined;
                }
                waitingCashing = item;
            }
        }
        if (!waitingCashing) {
            return undefined;
        }
        return reconciliation;
    }

    get currentAccountType() {
        let docType;
        if (this.reconciliationItems.length === 1) {
            const item = this.reconciliationItems[0];
            if (item.bt && item.accountingLine.accountableAccount) {
                if (item.accountingLine.accountableAccount.name.startsWith("455000")) {
                    return "CURRENT_ACCOUNT";
                }
                if (item.accountingLine.accountableAccount.name.startsWith("180000")) {
                    return "OPERATOR_ACCOUNT";
                }
                if (item.accountingLine.accountableAccount.name.startsWith("467000")) {
                    return "DEBIT_CREDIT_ACCOUNT";
                }
            }
        } else {
            let btAl;
            for (const item of this.reconciliationItems) {
                if (item.accountingLine.document) {
                    if (
                        item.accountingLine.document.type === "CURRENT_ACCOUNT" ||
                        item.accountingLine.document.type === "OPERATOR_ACCOUNT"
                    ) {
                        docType = item.accountingLine.document.type;
                    } else {
                        docType = undefined;
                        break;
                    }
                } else if (item.bt) {
                    if (!btAl) {
                        btAl = item.accountingLine;
                    }
                } else {
                    docType = undefined;
                    break;
                }
            }
            return btAl ? docType : undefined;
        }
        return docType;
    }

    getCurrentAccountType(group) {
        let docType;
        if (!group) {
            return docType;
        }
        if (group.items.length === 1) {
            const item = group.items[0];
            if (item.bt && item.accountingLine.accountableAccount) {
                if (item.accountingLine.accountableAccount.name.startsWith("455000")) {
                    return "CURRENT_ACCOUNT";
                }
                if (item.accountingLine.accountableAccount.name.startsWith("180000")) {
                    return "OPERATOR_ACCOUNT";
                }
                if (item.accountingLine.accountableAccount.name.startsWith("467000")) {
                    return "DEBIT_CREDIT_ACCOUNT";
                }
            }
        } else {
            let btAl;
            for (const item of group.items) {
                if (item.accountingLine.document) {
                    if (
                        item.accountingLine.document.type === "CURRENT_ACCOUNT" ||
                        item.accountingLine.document.type === "OPERATOR_ACCOUNT"
                    ) {
                        docType = item.accountingLine.document.type;
                    } else {
                        docType = undefined;
                        break;
                    }
                } else if (item.bt) {
                    if (!btAl) {
                        btAl = item.accountingLine;
                    }
                } else {
                    docType = undefined;
                    break;
                }
            }
            return btAl ? docType : undefined;
        }
        return docType;
    }

    isThirdPartyGroup(group): string {
        for (const item of group.items) {
            if (
                item.accountingLine?.accountableAccount &&
                (item.accountingLine.accountableAccount.name.startsWith("401") ||
                    item.accountingLine.accountableAccount.name.startsWith("411"))
            ) {
                return item.accountingLine.accountableAccount.name;
            }
        }
        return "";
    }

    get title() {
        return "Affectation | Lettrage";
        // let title = "";
        // if (this.isAccountingUser) {
        // title = "Lettrage";
        // }
        // if (this.cashBoxWithBTReconciliation) {
        //     title += title ? " mouvement bancaire | caisse" : " Mouvement bancaire | caisse"
        //     return title;
        // }
        // if (this.currentAccountType) {
        //     if (this.currentAccountType === "CURRENT_ACCOUNT") {
        //         title = "Compte courant"
        //     } else if (this.currentAccountType === "OPERATOR_ACCOUNT") {
        //         title = "Compte de l'exploitant"
        //     } else if (this.currentAccountType === "DEBIT_CREDIT_ACCOUNT") {
        //         title = "Compte débiteur créditeur"
        //     }
        //     for (const item of this.reconciliationItems) {
        //         if (item.accountingLine.user) {
        //             title += " de " + getUserDisplayName(item.accountingLine.user)
        //             break;
        //         } else if (item.accountingLine.document && item.accountingLine.document.owner) {
        //             title += " de " + getUserDisplayName(item.accountingLine.document.owner)
        //             break
        //         }
        //     }
        // }

        // if (!title) {
        //     title = "Justifier cette transaction"
        // }
        // return title;
    }

    get status() {
        if (this.reconciliation && this.reconciliation.id) {
            if (this.reconciliation.type === "CURRENT_ACCOUNT") return "Compte courant";
            if (this.reconciliation.type === "OPERATOR_ACCOUNT") return "Compte de l'exploitant";
            if (this.reconciliation.type === "ZTILL_RECEIPT") return "Z  de caisse";
            if (this.reconciliation.type === "CASH_BOX") return "Réglée en espèce";
            if (this.reconciliation.type === "DONE") return "Rapprochement importé";
            if (this.reconciliation.status === "EDITION") {
                return "Vérification à terminer";
            }
            if (this.reconciliation.status === "VALIDATED") {
                return "Vérifié";
            }
            if (
                this.reconciliation.status === "PENDING_VALIDATION_FROM_CLIENT" ||
                this.reconciliation.status === "PENDING_VALIDATION"
            ) {
                return "A vérifier par le cabinet";
            }
        }
        return "Aucun justificatif n'a été associé à cette transaction";
    }

    subAccountableAccount(item) {
        if (item.bt && item.bt.amount < 0) {
            return false;
        }
        if (
            item.doc &&
            (item.doc.type === "BANK_CHARGE" ||
                item.doc.type === "WITHOUT_INVOICE" ||
                item.doc.type === "WITH_DELTA" ||
                item.doc.type === "SALES_INVOICE_AUTO" ||
                item.doc.type === "EXPENSE_REPORT" ||
                item.doc.type === "ZTILL_RECEIPT")
        ) {
            return false;
        }

        return true;
    }

    computeReconciliationItems(splice: boolean = true) {
        this.itemReconciliations = {};
        const ids = {};
        if (splice) {
            this.groupedAccountingLines = [];
            this.reconciliationItems = [];
        } else {
            for (const item of this.reconciliationItems) {
                ids[item.id] = true;
            }
        }

        if (
            this.reconciliation &&
            ((this.reconciliation.bankTransactions &&
                this.reconciliation.bankTransactions.length) ||
                (this.reconciliation.accountingLines && this.reconciliation.accountingLines.length))
        ) {
            //
            // to manage pending validation with bt with accountingLines inside
            //
            //
            // DEPRECATED
            //
            let addPendingValidationDocuments = true;
            let btAlFoundForReconciliation = false;
            if (
                this.reconciliation.bankTransactions.length &&
                (this.reconciliation.status === "PENDING_VALIDATION" ||
                    this.reconciliation.status === "PENDING_VALIDATION_FROM_CLIENT")
            ) {
                const bt = this.reconciliation.bankTransactions[0];
                if (bt.accountingLines.length) {
                    if (this.reconciliation.accountingLines.length === 1) {
                        // let removeReconciliation = false
                        const docAl = this.reconciliation.accountingLines[0];
                        let btAl;
                        // let amountSigned = bt.amount
                        let amountSigned = 0.0;
                        for (const al of bt.accountingLines) {
                            if (
                                !al.reconciliation &&
                                Math.abs(al.amountSigned + docAl.amountSigned) < 1e-2
                            ) {
                                if (btAl) {
                                    btAl = undefined;
                                    break;
                                }
                                btAl = al;
                            }
                            amountSigned += al.amountSigned;
                        }
                        if (btAl) {
                            if (
                                btAl.thirdPartyCompany &&
                                docAl.thirdPartyCompany &&
                                btAl.thirdPartyCompany.id === docAl.thirdPartyCompany.id
                            ) {
                                btAl.pendingValidationReconciliation = this.reconciliation;
                                btAlFoundForReconciliation = true;
                                // btAl.reconciliation = undefined
                            } else {
                                bt.accountingLines = [];
                            }
                        } else if (Math.abs(amountSigned - docAl.amountSigned) >= 1e-2) {
                            addPendingValidationDocuments = false;
                            // btAl.reconciliation = undefined
                        }
                    }
                }
            }

            for (let i = 0; i < this.reconciliation.bankTransactions.length; i++) {
                const bt = this.reconciliation.bankTransactions[i];
                if (!ids[bt.id]) {
                    if (addPendingValidationDocuments && !btAlFoundForReconciliation) {
                        bt.reconciliation = this.reconciliation;
                    }
                    this.getBTItems(bt, true, true);
                    // this.addRecItem(item)
                    ids[bt.id] = true;
                }
            }
            if (addPendingValidationDocuments) {
                for (let i = 0; i < this.reconciliation.accountingLines.length; i++) {
                    const al = this.reconciliation.accountingLines[i];
                    if (!ids[al.id]) {
                        if (al.document) {
                            const item = this.getDocAccountingLineItem(al, true, true);
                            if (!item) {
                                continue;
                            }
                            this.addRecItem(item);
                            ids[al.document.id] = true;
                        } else if (al.bankTransaction) {
                            const item = this.getBTAccountingLineItem(
                                al.bankTransaction,
                                al,
                                true,
                                true,
                            );
                            this.addRecItem(item);
                            ids[al.bankTransaction.id] = true;
                        }
                        ids[al.id] = true;
                    }
                }
                if (
                    this.reconciliation.toReplaceAccountingLineSuggestions &&
                    this.reconciliation.toReplaceAccountingLineSuggestions.length
                ) {
                    this.reconciliation.toReplaceAccountingLineSuggestionItems = [];
                    for (const al of this.reconciliation.toReplaceAccountingLineSuggestions) {
                        if (!ids[al.id]) {
                            const item = this.getDocAccountingLineItem(al, true, true);
                            if (!item) {
                                continue;
                            }
                            this.reconciliation.toReplaceAccountingLineSuggestionItems.push(item);
                            ids[al.id] = true;
                            if (al.document) {
                                ids[al.document.id] = true;
                            }
                        }
                    }
                }
            }
        }
        if (this.bankTransaction && this.bankTransaction.id && !ids[this.bankTransaction.id]) {
            this.getBTItems(this.bankTransaction, true, true);
        }
        if (this.accountingLine && this.document && this.document.id && !ids[this.document.id]) {
            this.getDocItems(this.accountingLine, true, true);
        }
    }

    addRecItem(item) {
        // if (item.doc && item.doc.bankTransaction) {
        //     if (item.doc.bankTransaction) {
        //         const index = this.reconciliationItems.findIndex(ri => ri.id === item.doc.bankTransaction.id);
        //         if (index !== -1) {
        //             this.reconciliationItems.splice(index + 1, 0, item);
        //             return
        //         }
        //     }
        // }
        if (item.accountingLine && item.accountingLine.reconciliation) {
            const index = this.reconciliationItems.findIndex(
                (ri) =>
                    ri.accountingLine &&
                    ri.accountingLine.reconciliation &&
                    ri.accountingLine.reconciliation.id === item.accountingLine.reconciliation.id,
            );
            if (index !== -1) {
                this.reconciliationItems.splice(index + 1, 0, item);
                return;
            }
            //
            const foundGroup = this.groupedAccountingLines.find(
                (group) =>
                    group.reconciliation &&
                    item.accountingLine.reconciliation &&
                    group.reconciliation.id === item.accountingLine.reconciliation.id,
            );
            if (foundGroup) {
                foundGroup.items.push(item);
            } else {
                this.groupedAccountingLines.push({
                    reconciliation: item.accountingLine.reconciliation,
                    items: [item],
                });
            }
            return;
        }
        this.groupedAccountingLines.push({
            items: [item],
        });
        this.reconciliationItems.push(item);
    }

    getDocAccountingLineItem(accountingLine, selected: boolean, initial: boolean) {
        if (accountingLine?.accountableAccount?.name?.startsWith("SALES")) {
            return null;
        }
        const doc = accountingLine.document;
        const date = accountingLine.date
            ? moment(accountingLine.date).format("DD-MM-YYYY")
            : doc.date
              ? moment(doc.date).format("DD-MM-YYYY")
              : "-";
        const invoiceNumber =
            doc && doc.type === "SALES_INVOICE" && doc.invoiceNumber
                ? " - " + doc.invoiceNumber
                : "";
        const item = {
            accountingLine,
            selected,
            initial,
            doc,
            id: doc ? doc.id : "",
            type: "Document",
            iconType: "$receipt",
            name: accountingLine.wording + invoiceNumber,
            date,
            credit: 0.0,
            debit: 0.0,
            signedUrl: "",
            //
            // see how to get accountableAccount
            //
            accountableAccountAuto: null,
            accountableAccount: null,

            accountableAccountSuggestions: [],
            // subCreditTotal: 0.0,
            // subDebitTotal: 0.0,
            // credit_1: 0.0,
            // debit_1: 0.0,
            // accountableAccount1: undefined,
            // validated_1: false,
            // credit_2: 0.0,
            // debit_2: 0.0,
            // accountableAccount2: undefined,
            // validated_2: false,
            amountSigned: accountingLine.amountSigned,
            // netAmount: 0.0,
            // netAmount_1: 0.0,
            // netAmount_2: 0.0
            suppliers: "",
            customers: "",
            user: "",
            bankAccount: "",
            editable: true,
        };

        if (
            accountingLine &&
            accountingLine.reconciliation &&
            accountingLine.reconciliation.accountingItemImport
        ) {
            item.editable = false;
        }

        this.computeDisabledAccountableAccount(item);
        // sub value
        this.updateDebitCredit(item);
        // if (accountingLine.amountSigned < 0) {
        //     item.debit = -accountingLine.amountSigned;
        //     item.subDebitTotal = doc && doc.netAmount !== undefined ? doc.netAmount : -accountingLine.amountSigned;
        // } else {
        //     item.credit = accountingLine.amountSigned;
        //     item.subCreditTotal = doc && doc.netAmount !== undefined ? doc.netAmount : accountingLine.amountSigned;
        // }
        if (doc) {
            // item.accountableAccountAuto = doc.accountableAccountAuto
            // item.accountableAccount = doc.accountableAccount
            if (doc.signedUrl) {
                item.signedUrl = doc.signedUrl;
            }
        }
        this.updateThirdParty(item);

        return item;
    }

    updateThirdParty(item) {
        item.suppliers = "";
        item.customers = "";
        item.user = "";
        item.bankAccount = "";
        if (item.accountingLine) {
            const al = item.accountingLine;
            if (al.thirdPartyCompany && item.accountingLine.accountableAccount) {
                if (item.accountingLine.accountableAccount.name.startsWith("401")) {
                    item.suppliers = item.suppliers ? (item.suppliers += " - ") : "";
                    item.suppliers += al.thirdPartyCompany.shortName || al.thirdPartyCompany.name;
                } else if (item.accountingLine.accountableAccount.name.startsWith("411")) {
                    item.customers = item.customers ? (item.customers += " - ") : "";
                    item.customers += al.thirdPartyCompany.shortName || al.thirdPartyCompany.name;
                }
            }
            if (al.user) {
                item.user = item.user ? (item.user += " - ") : "";
                item.user += getUserDisplayName(al.user);
            }
            if (al.bankAccount) {
                item.bankAccount += al.bankAccount.name;
            }
        }
    }

    updateDebitCredit(item) {
        if (item.amountSigned >= 0) {
            item.debit = item.amountSigned;
        } else {
            item.credit = -item.amountSigned;
        }
    }

    containsDocumentToValidate(group) {
        for (const item of group.items) {
            if (item.doc && item.doc.status !== "VALIDATED") {
                return item;
            }
        }
        return null;
    }

    showValidateReconciliation(group) {
        if (!group.reconciliation || group.reconciliation.acountingItemImport) {
            return false;
        }
        if (
            (group.reconciliation.id && group.reconciliation.status === "PENDING_VALIDATION") ||
            group.reconciliation.status === "PENDING_VALIDATION_FROM_CLIENT"
        ) {
            return true;
        }
        return false;
    }

    getReconciliationValidationType(group) {
        if (!group.reconciliation || group.reconciliation.acountingItemImport) {
            return "";
        }
        if (
            (group.reconciliation.id && group.reconciliation.status === "PENDING_VALIDATION") ||
            group.reconciliation.status === "PENDING_VALIDATION_FROM_CLIENT"
        ) {
            return group.reconciliation.status;
        }
        return "";
    }

    get waitingForValidation() {
        for (const item of this.reconciliationItems) {
            if (this.showValidateReconciliation(item)) {
                return true;
            }
        }
        return false;
    }

    computeReconciliations(item) {
        if (item.accountingLine.reconciliation) {
            if (this.itemReconciliations[item.accountingLine.reconciliation.id]) {
                item.disabledAccountableAccount = true;
                this.itemReconciliations[
                    item.accountingLine.reconciliation.id
                ].accountingLines.push(item.accountingLine);
            } else {
                this.itemReconciliations[item.accountingLine.reconciliation.id] = {
                    id: item.accountingLine.reconciliation.id,
                    accountingLines: [item.accountingLine],
                };
            }
        }
    }

    computeDisabledAccountableAccount(item) {
        this.computeReconciliations(item);
        if (item.disabledAccountableAccount) {
            return;
        }
        if (item.doc && item.doc.acountingItemImport) {
            item.disabledAccountableAccount = true;
            return;
        }
        if (item.bt && item.bt.acountingItemImport) {
            item.disabledAccountableAccount = true;
            return;
        }
        if (!this.isAccountingUser) {
            item.disabledAccountableAccount = true;
            return;
        }

        if (item.accountingLine) {
            if (item.accountingLine.accountableAccount) {
                if (
                    item.accountingLine.accountableAccount.name.startsWith("531000") ||
                    item.accountingLine.accountableAccount.name.startsWith("512") ||
                    item.accountingLine.accountableAccount.name === "INTERNAL_LINK" ||
                    item.accountingLine.accountableAccount.name.startsWith("511000") ||
                    (item.accountingLine.accountableAccount.name.startsWith("421000") &&
                        item.accountingLine.reconciliation) ||
                    item.accountingLine.accountableAccount.name.startsWith("580") ||
                    item.accountingLine.accountableAccount.name.startsWith("511") ||
                    item.accountingLine.accountableAccount.name.startsWith("455000") ||
                    item.accountingLine.accountableAccount.name.startsWith("467000") ||
                    item.accountingLine.accountableAccount.name.startsWith("108000")
                ) {
                    item.disabledAccountableAccount = true;
                }
            }
        }
    }

    getBTAccountingLineItem(
        bt,
        accountingLine,
        selected: boolean,
        initial: boolean,
        isBT512: boolean = false,
    ) {
        const date = accountingLine.date ? moment(accountingLine.date).format("DD-MM-YYYY") : "-";
        const item = {
            selected,
            initial,
            bt,
            id: bt.id,
            accountingLine,
            iconType:
                bt.account && bt.account.type === "CASH_BOX"
                    ? "$fa-cash-register"
                    : "$fa-university",
            name: accountingLine.wording || bt.wordingDisplay || bt.wordingOriginal,
            date,
            credit: 0.0,
            debit: 0.0,
            signedUrl: "",
            disabledAccountableAccount: false,
            accountableAccount: accountingLine.accountableAccount,
            accountableAccountSuggestions: [],
            amountSigned: accountingLine.amountSigned,
            suppliers: "",
            customers: "",
            user: "",
            bankAccount: "",
            editable: true,
            is471AL: accountingLine.accountableAccount?.name?.startsWith("471000"),
            isBT512,
        };

        if (
            accountingLine &&
            accountingLine.reconciliation &&
            accountingLine.reconciliation.accountingItemImport
        ) {
            item.editable = false;
        }

        this.computeDisabledAccountableAccount(item);
        this.updateThirdParty(item);
        if (isBT512) {
            item.bankAccount = bt.account ? bt.account.name : "";
        }

        this.updateDebitCredit(item);
        return item;
    }

    getDocItems(accountingLine, selected: boolean, initial: boolean) {
        if (accountingLine.reconciliation) {
            if (accountingLine.reconciliation.bankTransactions) {
                for (const bt of accountingLine.reconciliation.bankTransactions) {
                    bt.reconciliation = accountingLine.reconciliation;
                    // HACK DUE TO GRAPQL QUERY BUG
                    // bt.accountableAccount = accountingLine.accountableAccount
                    // END HACK
                    this.getBTItems(bt, selected, initial);
                }
            }
            for (const subAccountingLine of accountingLine.reconciliation.accountingLines) {
                subAccountingLine.reconciliation = accountingLine.reconciliation;
                if (subAccountingLine.bankTransaction) {
                    const item = this.getBTAccountingLineItem(
                        subAccountingLine.bankTransaction,
                        subAccountingLine,
                        selected,
                        initial,
                    );
                    this.addRecItem(item);
                } else if (subAccountingLine.document) {
                    const item = this.getDocAccountingLineItem(
                        subAccountingLine,
                        selected,
                        initial,
                    );
                    if (!item) {
                        continue;
                    }
                    this.addRecItem(item);
                }
            }
        } else {
            const item = this.getDocAccountingLineItem(accountingLine, selected, initial);
            if (!item) {
                return;
            }
            this.addRecItem(item);
        }
    }

    getAvailableBTItems(bt, availableBankTransactions) {
        const amountSigned = computeNotJustifiedAmountSigned(bt, bt.accountingLines);

        if (bt.accountingLines && bt.accountingLines.length) {
            for (const accountingLine of bt.accountingLines) {
                if (
                    accountingLine.accountableAccount?.name &&
                    this.$store.state.accountableAccountTable
                ) {
                    const dbAA = this.$store.state.accountableAccountTable.accountableAccounts.find(
                        (aa) => aa.name === accountingLine.accountableAccount.name,
                    );
                    if (!accountingLine.reconciliation && dbAA?.lettering) {
                        accountingLine.bankTransaction = bt;
                        const item = this.getBTAccountingLineItem(bt, accountingLine, false, false);
                        availableBankTransactions.push(item);
                    }
                }
            }
        }
        if (Math.abs(amountSigned) >= 1e-2) {
            if (
                !bt.notJustifiedAmountSigned ||
                Math.abs(bt.notJustifiedAmountSigned - amountSigned) > 1e-4
            ) {
                bt.notJustifiedAmountSigned = amountSigned;
            }
            const accountingLine = {
                id: "",
                wording: bt.wordingDisplay || bt.wordingOriginal,
                date: bt.dateDebit,
                accountableAccount: this.waitingAA,
                amountSigned: -amountSigned,
                reconciliation: bt.reconciliation,
                bankTransaction: bt,
            };
            const item = this.getBTAccountingLineItem(bt, accountingLine, false, false);
            availableBankTransactions.push(item);
        }
    }

    getBTItems(bt, selected: boolean, initial: boolean) {
        const notJustifiedAmountSigned = computeNotJustifiedAmountSigned(bt, bt.accountingLines);
        let isBT512 = true;
        if (bt.version !== 2 && bt.version !== 3) {
            const mainAccountingLine = {
                id: "",
                wording: bt.wordingDisplay || bt.wordingOriginal,
                date: bt.dateDebit,
                accountableAccount: this.bankAA,
                amountSigned: bt.amount,
                bankTransaction: bt,
            };
            const item = this.getBTAccountingLineItem(
                bt,
                mainAccountingLine,
                selected,
                initial,
                true,
            );
            this.addRecItem(item);
            isBT512 = false;
        }

        if (bt.accountingLines && bt.accountingLines.length) {
            for (const accountingLine of bt.accountingLines) {
                if (accountingLine.reconciliation) {
                    for (const subAccountingLine of accountingLine.reconciliation.accountingLines) {
                        subAccountingLine.reconciliation = accountingLine.reconciliation;
                        if (subAccountingLine.bankTransaction) {
                            const item = this.getBTAccountingLineItem(
                                subAccountingLine.bankTransaction,
                                subAccountingLine,
                                selected,
                                initial,
                            );
                            this.addRecItem(item);
                        } else if (subAccountingLine.document) {
                            const item = this.getDocAccountingLineItem(
                                subAccountingLine,
                                selected,
                                initial,
                            );
                            if (!item) {
                                continue;
                            }
                            this.addRecItem(item);
                        }
                    }
                } else if (accountingLine.document) {
                    const item = this.getDocAccountingLineItem(accountingLine, selected, initial);
                    if (!item) {
                        continue;
                    }
                    this.addRecItem(item);
                } else {
                    accountingLine.bankTransaction = bt;
                    accountingLine.reconciliation = accountingLine.pendingValidationReconciliation;
                    let localIsBT512 = isBT512
                        ? accountingLine.accountableAccount?.name?.startsWith("512")
                        : false;
                    const item = this.getBTAccountingLineItem(
                        bt,
                        accountingLine,
                        selected,
                        initial,
                        localIsBT512,
                    );
                    this.addRecItem(item);
                    if (localIsBT512) {
                        isBT512 = false;
                    }
                }
                // amountSigned += accountingLine.amountSigned
            }
        }
        if (Math.abs(notJustifiedAmountSigned) > 1e-6) {
            if (
                !bt.notJustifiedAmountSigned ||
                Math.abs(bt.notJustifiedAmountSigned - notJustifiedAmountSigned) > 1e-4
            ) {
                debugger; // git-ignore
                bt.notJustifiedAmountSigned = notJustifiedAmountSigned;
            }
            const accountingLine = {
                id: "",
                wording: bt.wordingDisplay || bt.wordingOriginal,
                date: bt.dateDebit,
                accountableAccount: this.waitingAA,
                amountSigned: -notJustifiedAmountSigned,
                reconciliation: bt.reconciliation,
                bankTransaction: bt,
            };
            const item = this.getBTAccountingLineItem(bt, accountingLine, selected, initial);
            this.addRecItem(item);
        }

        for (const group of this.groupedAccountingLines) {
            for (const item of group.items) {
                if (item.id === bt.id) {
                    group.mainItem = item;
                    break;
                }
            }
            group.items.sort((i1, i2) => {
                if (i1.bt && i1.bt.id === bt.id) return -1;
                return 1;
            });
        }
    }

    //
    // CHAT
    //

    open_chat: boolean = false;

    wishStatus: string = "";

    getChatSubTitle() {
        if (this.wishStatus === "INFORMATION_REQUEST") {
            return "Demande d'information";
        }
        if (this.wishStatus === "DENIED") {
            return "Rejeter";
        }
        return "Réponse";
    }

    setOpenChat(reason) {
        if (!this.open_chat) {
            this.open_chat = true;
        }
        this.wishStatus = reason;
    }

    get openChat() {
        if (!this.$store.state.user.profile.configuration.chat.read) return false;
        // if (this.reconciliation && this.reconciliation.chat) {
        //     return true;
        // }
        if (this.reconciliation && this.reconciliation.id) {
            return false;
        }
        if (this.bankTransaction && this.bankTransaction.chat) {
            return true;
        }
        return this.open_chat;
    }

    get chatId() {
        // if (this.reconciliation) {
        //     return this.reconciliation.chat ? this.reconciliation.chat.id : ''
        // }
        if (this.bankTransaction) {
            return this.bankTransaction.chat ? this.bankTransaction.chat.id : "";
        }
        return "";
    }

    async onMessageSent(data) {
        let update = false;
        if (this.reconciliation && this.reconciliation.id) {
            debugger;
            return;
        }
        if (!this.bankTransaction) {
            debugger;
            return;
        }
        // if (!this.reconciliation && !this.bankTransaction) {
        //     debugger;
        //     return;
        // }
        const variables: any = {
            // id: this.reconciliation ? this.reconciliation.id : this.bankTransaction.id,
            id: this.bankTransaction.id,
            chat: undefined,
        };
        if (this.wishStatus) {
            variables.status = this.wishStatus;
            update = true;
            this.wishStatus = undefined;
        }
        // if (this.reconciliation) {
        //     if (!this.reconciliation.chat) {
        //         variables.chat = { connect: { id: data.chatId } }
        //         this.reconciliation.chat = { id: data.chatId };
        //         update = true;
        //     } else if (this.reconciliation.chat.id !== data.chatId) {
        //         debugger;
        //     }
        //     if (update) {
        //         await this.$apollo.mutate({
        //             mutation: UPDATE_RECONCILIATION_CHAT,
        //             variables: variables
        //         });
        //     }
        // } else
        if (this.bankTransaction) {
            if (!this.bankTransaction.chat) {
                variables.chat = { connect: { id: data.chatId } };
                this.bankTransaction.chat = { id: data.chatId };
                update = true;
            } else if (this.bankTransaction.chat.id !== data.chatId) {
                debugger;
            }
            if (update) {
                await this.$apollo.mutate({
                    mutation: UPDATE_BANKTRANSACTION_CHAT,
                    variables: variables,
                });
            }
        } else {
            debugger;
        }
    }

    onShowMessageChanged(data) {
        this.open_chat = data;
        this.wishStatus = "";
    }

    //
    // Status
    //
    groupStatus(group) {
        if (!group || !group.items || !group.items.length) {
            return "XXX";
        }
        if (this.showValidateReconciliation(group)) {
            if (this.isAccountingUser) {
                return "Lettrage à valider";
            }
            return "Justifié";
        }

        if (group.items.length > 1) {
            if (this.isAccountingUser) {
                return "Affecté et lettré";
            }
            return "Justifié";
        }
        const firstItem = group.items[0];
        let title = this.getAllocationTitle(firstItem);

        if (this.isGroupWaitingLettering(group)) {
            if (title) title += " - ";
            if (this.isAccountingUser) {
                title = "A lettrer";
            } else {
                title = "A justifier";
            }
        }

        if (this.showGroupAccountableAccount(group)) {
            if (title) {
                title += " ";
            }
            const aa = this.getIfNecessaryAccountableAccount(group, 0);
            if (this.isAccountingUser) {
                title += "(" + aa + ")";
            } else {
                title += ": " + this.$t("accountableAccount." + aa);
            }
        }
        return title;
    }

    groupStatusWithoutAA(group) {
        if (!group || !group.items || !group.items.length) {
            return "XXX";
        }
        if (group.items[0].isBT512) {
            return "";
        }
        if (this.showValidateReconciliation(group)) {
            if (this.isAccountingUser) {
                return "Lettrage à valider";
            }
            return "Justifié";
        }

        if (group.items.length > 1) {
            if (this.isAccountingUser) {
                return "Affecté et Lettré";
            }
            return "Justifié";
        }
        const firstItem = group.items[0];
        let title = this.getAllocationTitle(firstItem);

        if (this.isGroupWaitingLettering(group)) {
            if (title) {
                title += " - ";
            }
            if (this.isAccountingUser) {
                title += "A lettrer";
            } else {
                title += "A justifier";
            }
        }
        return title;
    }

    isGroupWaitingLettering(group) {
        if (group.reconciliation) {
            debugger;
            return undefined;
        }
        if (group.items.length > 1) {
            debugger;
            return undefined;
        }
        const item = group.items[0];
        if (!item.editable) {
            return undefined;
        }

        if (!item.accountingLine.accountableAccount) {
            debugger;
            return undefined;
        }
        if (!this.$store.state.accountableAccountTable) {
            debugger;
            return undefined;
        }
        const dbAA = this.$store.state.accountableAccountTable.accountableAccounts.find(
            (aa) => aa.name === item.accountingLine.accountableAccount.name,
        );
        if (!dbAA?.lettering) {
            return undefined;
        }
        return item;
    }

    groupReconciliationStatus(group) {
        if (!group || !group.items || !group.items.length) {
            return "XXX";
        }
        if (this.showValidateReconciliation(group)) {
            if (this.isAccountingUser) {
                return "Lettrage à valider";
            }
            return "Justifié";
        }
        if (group.items.length > 1) {
            if (this.isAccountingUser) {
                return "Lettré";
            }
            return "Justifié";
        }
        const aa = this.getIfNecessaryAccountableAccount(group, 0);
        if (aa.startsWith("108") || aa.startsWith("455") || aa.startsWith("511")) {
            return "OK";
        }
        if (this.isAccountingUser) {
            return "A lettrer";
        }
        return "A justifier";
    }

    getThirdPartyCompanies(group) {
        for (const item of group.items) {
            if (item.suppliers) {
                return item.suppliers;
            }
            if (item.customers) {
                return item.customers;
            }
        }
        return "";
    }

    getUser(group) {
        for (const item of group.items) {
            if (item.user) {
                return item.user;
            }
        }
        return "";
    }

    getSpecificationReconciliation(group) {
        for (const item of group.items) {
            if (item.doc) {
                if (item.doc.type === "WITHOUT_INVOICE") {
                    return "Sans justificatif";
                }
                if (item.doc.type === "SALES_INVOICE_AUTO") {
                    return "Encaissement";
                }
                if (item.doc.type === "ZTILL_RECEIPT") {
                    return "Z de caisse";
                }
                if (item.doc.type === "BANK_CHARGE") {
                    return "Commission bancaire";
                }
            }
        }
        return "";
    }

    groupAllocation(group) {
        if (!group || !group.items || !group.items.length) {
            return "XXX";
        }

        const firstItem = group.items[0];
        let title = this.getAllocationTitle(firstItem);

        if (this.showGroupAccountableAccount(group)) {
            const aa = this.getIfNecessaryAccountableAccount(group, 0);
            if (this.isAccountingUser) {
                title += " (" + aa + ")";
            } else {
                let suffix;
                if (aa.startsWith("401") || aa.startsWith("411")) {
                    suffix = this.getThirdPartyCompanies(group);
                } else if (aa.startsWith("421") || aa.startsWith("455") || aa.startsWith("108")) {
                    suffix = this.getUser(group);
                } else {
                    suffix = this.$t("accountableAccount." + aa);
                }
                if (title && suffix) {
                    title += " : ";
                }
                if (suffix) {
                    title += suffix;
                }
            }
        }
        if (!title) {
            title = this.getSpecificationReconciliation(group);
        }
        if (!title) {
            title = "A affecter";
        }
        return title;
    }

    showGroupAccountableAccount(group) {
        return this.showAccountableAccount(group.items[0]);
    }

    showAccountableAccount(item) {
        if (item.accountingLine) {
            if (item.accountingLine.accountableAccount) {
                if (item.accountingLine.accountableAccount.name.startsWith("512")) return false;
                if (item.accountingLine.accountableAccount.name === "INTERNAL_LINK") return false;
            }
        }
        return true;
    }

    getIfNecessaryAccountableAccount(group, index) {
        if (!group || !group.items || !group.items.length) {
            return "";
        }
        const firstItem = group.items[0];
        if (!firstItem.accountingLine || !firstItem.accountingLine.accountableAccount) {
            return "XXXXXX";
        }
        if (index === 0) {
            if (firstItem.accountingLine.accountableAccount.name === "INTERNAL_LINK") return "";
            return firstItem.accountingLine.accountableAccount.name;
        }
        const item = group.items[index];
        if (!item.accountingLine || !item.accountingLine.accountableAccount) {
            return "XXXXXX";
        }

        if (
            item.accountingLine.accountableAccount.name !==
            firstItem.accountingLine.accountableAccount.name
        ) {
            const aa = item.accountingLine.accountableAccount.name;
            if (
                this.isIncomingOutgoingPayment &&
                (aa.startsWith("401000") || aa.startsWith("411000"))
            ) {
                return "";
            }
            return aa;
        }
        return "";
    }

    getIfNecessaryAccountableAccountColor(group, index) {
        if (!group || !group.items || !group.items.length) {
            return "color:red;";
        }
        const firstItem = group.items[0];
        if (!firstItem.accountingLine || !firstItem.accountingLine.accountableAccount) {
            return "color:red;";
        }
        if (index === 0) {
            return "";
        }
        const item = group.items[index];
        if (!item.accountingLine || !item.accountingLine.accountableAccount) {
            return "color:red;";
        }

        if (
            item.accountingLine.accountableAccount.name !==
            firstItem.accountingLine.accountableAccount.name
        ) {
            return "color:red;";
        }
        return "";
    }

    getAllocationTitle(item) {
        let title = "Autre";
        if (item.accountingLine.accountableAccount?.name) {
            if (item.accountingLine.accountableAccount.name.startsWith("401000")) {
                title = "Achat";
            } else if (item.accountingLine.accountableAccount.name.startsWith("411000")) {
                title = "Vente";
            } else if (item.accountingLine.accountableAccount.name.startsWith("421000")) {
                title = "Sociale";
            } else if (
                socialAccountableAccounts.indexOf(item.accountingLine.accountableAccount.name) !==
                -1
            ) {
                title = "Sociale";
            } else if (
                stateAccountableAccounts.indexOf(item.accountingLine.accountableAccount.name) !== -1
            ) {
                title = "Etat";
            } else if (item.accountingLine.accountableAccount.name.startsWith("455000")) {
                title = "Compte courant";
            } else if (item.accountingLine.accountableAccount.name.startsWith("108000")) {
                title = "Compte de l'exploitant";
            } else if (item.accountingLine.accountableAccount.name.startsWith("467000")) {
                title = "Compte débiteur|créditeur";
            } else if (
                item.accountingLine.accountableAccount.name.startsWith("511") ||
                item.accountingLine.accountableAccount.name.startsWith("531") ||
                item.accountingLine.accountableAccount.name.startsWith("580")
            ) {
                title = "Z de caisse";
            } else if (item.accountingLine.accountableAccount.name.startsWith("66")) {
                title = "Charges Financières";
            } else if (item.accountingLine.accountableAccount.name.startsWith("6")) {
                title = "Achat";
            } else if (item.accountingLine.accountableAccount.name.startsWith("7")) {
                title = "Vente";
            } else if (item.accountingLine.accountableAccount.name.startsWith("164")) {
                title = "Emprunt";
            } else if (item.accountingLine.accountableAccount.name.startsWith("627")) {
                title = "Commission";
            } else if (item.accountingLine.accountableAccount.name.startsWith("512")) {
                title = "Banque";
            } else if (item.accountingLine.accountableAccount.name.startsWith("471")) {
                title = "A affecter";
            }
            // else {
            //     title = "Autre"
            // }
        }
        return title;
    }

    showGroupNotReconciliatedAndWithImputation(group) {
        const item = this.getGroupNotReconciliatedAndWithImputation(group);
        if (!item) {
            return false;
        }
        return true;
    }

    getGroupNotReconciliatedAndWithImputation(group) {
        if (group.reconciliation) {
            return undefined;
        }
        if (group.items.length > 1) {
            return undefined;
        }
        const item = group.items[0];
        if (!item.editable) {
            return undefined;
        }
        if (!item.bt) return undefined;
        if (!item.accountingLine || !item.accountingLine.id || item.isBT512) return undefined;
        // if (!item.accountingLine.accountableAccount) return undefined
        return item;
    }
}
